import { Paper } from '@mantine/core';
import { ErrorBoundary } from '@sentry/react';
import { Outlet } from 'react-router-dom';

const ErrorHandling = () => {
  return (
    <Paper radius="lg" p="xl" shadow="xl" style={{ flex: 1 }} display="flex">
      something went wrong
    </Paper>
  );
};

const Message = () => {
  return (
    <ErrorBoundary fallback={<ErrorHandling />}>
      <Outlet />
    </ErrorBoundary>
  );
};

export default Message;
